import React from 'react';
import Lottie from 'lottie-react';
import animationData from '../../assets/payment_success.json';
import './PaymentStatus.css';

const PaymentSuccess = () => {

    return (
        <div className="payment-status-container">
            <div className="payment-status-card">
                <img src="/logo.png" alt="App Logo" className="payment-status-logo" />

                <div className="payment-status-lottie">
                    <Lottie
                        animationData={animationData}
                        loop={false}
                    />
                </div>

                <h1 className="payment-status-title success">Payment Successful!</h1>
                <p className="payment-status-message">
                    Thank you for your payment. Your transaction has been completed successfully. Your ticket has been sent to your email. Please check your inbox for the details.
                </p>

                <button
                    className="payment-status-button primary"
                    onClick={() => {
                        window.location.href = 'outrapp://share.outr-connect.com/share';
                    }}
                >
                    Return to Outr App
                </button>
            </div>
        </div>
    );
};

export default PaymentSuccess;
